'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Compatibility wrapper to fit the winres-services component
// into the old model winres-reservation-context way of doing
// things.

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[ServicesWrapper]');

var WinresServicesWrapperController = function () {
    function WinresServicesWrapperController($scope, $filter) {
        _classCallCheck(this, WinresServicesWrapperController);

        this.$scope = $scope;
        this.$filter = $filter;
    }

    _createClass(WinresServicesWrapperController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // List of main destinations and main products to get linked services for.
            // Example:
            // [
            //     {
            //         destCode: 'TLOVYO',
            //         prodCode: null,
            //         beginDate: '2020-01-11',
            //         beginDate: '2020-01-12'
            //     },
            //     {
            //         destCode: 'TLOVYO',
            //         prodCode: 'H2',
            //         beginDate: '2020-01-11',
            //         beginDate: '2020-01-12'
            //     },
            // ]
            this.mains = [];

            this.data = this.winresReservationContext.getContext();

            log('Existing product lines on init:', _.cloneDeep(this.data.Products));

            this.$scope.$watch(function () {
                return _this.data.Passengers;
            }, function () {
                return _this.updatePassengers();
            }, true);

            this.$scope.$watch(function () {
                return _this.getMains();
            }, function (mains) {
                return _this.updateMains(mains);
            }, true);

            this.$scope.$watch(function () {
                return _this.getProductLines();
            }, function (lines) {
                return _this.updateProductLines(lines);
            }, true);

            this.$scope.$watch(function () {
                return _this.form && _this.form.$valid && _this.mains && _this.mains.length > 0;
            }, function (valid) {
                if (valid) {
                    log('All required selections made.');
                    _this.winresReservationContext.setReservationComponentErrors('extraservices', 'services', []);
                } else {
                    log('Selections are not yet valid.');
                    _this.winresReservationContext.setReservationComponentErrors('extraservices', 'services', [{
                        Message: 'services.error_forced'
                    }]);
                }
            });
        }

        // Update the list of main destinations/products.
        // That means the PAAKOHDE/PAATUOTE/etc to search linkings for.

    }, {
        key: 'updateMains',
        value: function updateMains(ms) {
            this.mains = ms;
            // log('Updated mains:', this.mains);
        }
    }, {
        key: 'getMains',
        value: function getMains() {
            // Find the main destinations.
            var mainDests = [];
            // Assume there is only one main destination per booking.
            // If there is a selected departure, get the destination from it.
            var dep = this.data.SelectedDeparture;
            if (dep) {
                mainDests = [{
                    destCode: dep.DestinationCode,
                    prodCode: null, // Not linked to a specific product
                    beginDate: dep.DepartureDate,
                    endDate: dep.ArrivalDate2,
                    heading: this.$filter('i18next')('services.common_extra_services'),
                    passengerNumbers: null // No restriction, allow all passengers
                }];
            } else {}
            // Other means of finding the main destination are not implemented yet.
            // Need to check what the proper way is - maybe look at this.data.Destination
            // or take one of the accommodation products' destinations?


            // Find any accommodation products
            var accs = _.filter(this.data.Products, isAccommodation);

            // NOTE: It may become necessary to split accommodation products by product number,
            // if multiple accommodations of the same type (such as H2 rooms at the same hotel)
            // have been selected, and the extra service picks are to be shown separately for
            // each room.

            // Consider them to be main products
            var mainProds = _.map(accs, function (line) {
                var prod = line.Product;
                var di = prod.DestinationInfo;

                // Section heading for this main product's services
                var heading = di.ProductName;
                if (prod.Producer && prod.Producer.Company) {
                    heading += ' (' + prod.Producer.Company + ')';
                }

                // Find the passengers who are accommodated in this accommodation type.
                // Only they can pick the service.
                var passengerNumbers = _.map(line.PassengerAssignments, function (pa) {
                    return pa.PassengerNumber;
                });

                return {
                    destCode: di.DestinationCode,
                    prodCode: di.ProductCode,
                    beginDate: prod.BeginDate,
                    endDate: prod.EndDate,
                    heading: heading,
                    passengerNumbers: passengerNumbers
                };
            });

            return _.concat(mainDests, mainProds);
        }
    }, {
        key: 'updatePassengers',
        value: function updatePassengers() {
            var pass = this.winresReservationContext.getPassengersForPricing();

            if (!_.isArrayLike(pass)) {
                log.warn('No passengers available.');
                this.passengers = [];
                return;
            }

            if (pass.length > 0 && !pass[0].FirstName) {
                var names = this.winresReservationContext.getPassengerDisplayNames();
                // console.log('NAMES', names);
                _.forEach(pass, function (p, i) {
                    var name = names[i];
                    // console.log(name);
                    var space = name.indexOf(' ');
                    if (space > 0) {
                        p.FirstName = name.substring(0, space);
                        p.LastName = name.substring(space + 1);
                    } else {
                        p.FirstName = name;
                        p.LastName = '';
                    }
                });
            }

            this.passengers = pass;

            // log('Updated passengers:', this.passengers);
        }
    }, {
        key: 'getProductLines',
        value: function getProductLines() {
            var lines = this.data.Products;
            var serviceLines = _.filter(lines, function (line) {
                return line.IsService;
            });

            var byMain = {};
            _.forEach(this.mains, function (main, i) {
                // Find lines for this main destination/product
                var lines = _.filter(serviceLines, function (line) {
                    return mainsEqual(line.Main, main);
                });

                // Convert to simple lines for internal use
                byMain[i] = _.map(lines, function (line) {
                    return {
                        Amount: line.Amount,
                        DestinationCode: line.Product.DestinationInfo.DestinationCode,
                        ProductCode: line.Product.DestinationInfo.ProductCode,
                        BeginDate: line.Product.BeginDate,
                        EndDate: line.Product.EndDate,
                        PriceGroup: line.PriceGroup,
                        PassengerAssignments: line.PassengerAssignments,
                        PriceSelections: line.PriceSelections,
                        Link: line.Link,

                        WS_ProductName: line.Product.DestinationInfo.ProductName
                    };
                });
            });

            return byMain;
        }
    }, {
        key: 'updateProductLines',
        value: function updateProductLines(linesByMain) {
            this.serviceProductLines = linesByMain;
            // log('Updated product lines:', this.serviceProductLines);
        }
    }, {
        key: 'read',
        value: function read() {
            var _this2 = this;

            var valid = this.form && this.form.$valid;

            // Generate old-style product lines (currently used internally by the frontend)
            var complexProductLines = _.flatMap(this.mains, function (main, i) {
                var productLines = _this2.serviceProductLines[i];

                return _.map(productLines, function (line) {

                    var totalPrice = 0;
                    if (line.PassengerAssignments) {
                        totalPrice = _.sumBy(line.PassengerAssignments, function (pa) {
                            return pa.WS_Price;
                        });
                    } else if (line.PriceSelections) {
                        totalPrice = _.sumBy(line.PriceSelections, function (ps) {
                            return ps.Amount * ps.WS_UnitPrice;
                        });
                    }

                    return {
                        Amount: line.Amount,
                        Product: {
                            DestinationInfo: {
                                DestinationCode: line.DestinationCode,
                                ProductCode: line.ProductCode,
                                ProductName: line.WS_ProductName
                            },
                            BeginDate: line.BeginDate,
                            EndDate: line.EndDate,

                            // Internal use
                            Price: 0
                        },

                        PassengerAssignments: line.PassengerAssignments,
                        PriceSelections: line.PriceSelections,

                        PriceGroup: line.PriceGroup,

                        Link: line.Link,

                        // Internal use
                        IsService: true,
                        TotalPrice: totalPrice,
                        UnitPrice: null,
                        Main: main
                    };
                });
            });

            // log(complexProductLines);

            this.createProducts(complexProductLines);
        }
    }, {
        key: 'removeExistingServicesProducts',
        value: function removeExistingServicesProducts() {
            this.data.Products = _.filter(this.data.Products, function (line) {
                return !line.IsService;
            });
        }
    }, {
        key: 'createProducts',
        value: function createProducts(complexProductLines) {
            var _this3 = this;

            this.removeExistingServicesProducts();
            _.forEach(complexProductLines, function (cpl) {
                var line = _this3.winresReservationContext.findOrCreateProductLineByProduct(cpl.Product);
                _.assign(line, cpl);
            });
        }
    }]);

    return WinresServicesWrapperController;
}();

function mainsEqual(a, b) {
    if (a === b) {
        return true;
    } else if (!a || !b) {
        return false;
    } else {
        return a.destCode == b.destCode && a.prodCode == b.prodCode && a.beginDate == b.beginDate && a.endDate == b.endDate;
    }
}

function isAccommodation(line) {
    try {
        return line.Product.DestinationInfo.Accommodation;
    } catch (e) {
        console.warn('Failed to check if product is accommodation, assuming false.', e, line);
        return false;
    }
}

WinresServicesWrapperController.$inject = ['$scope', '$filter'];

_module3.default.component('winresServicesWrapper', {
    template: require('./winresServicesWrapper.html'),
    controller: WinresServicesWrapperController,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {}
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresServicesWrapper/winresServicesWrapper.js
// module id = 449
// module chunks = 2